import React from "react";
import {OrbitComponent} from "../../../components/base-components/orbit-component/orbit-component";
import {ToggleSwitchCheckboxBox} from "./boxes/checkbox/toggle-switch-checkbox.box";
import {ToggleSwitchSliderBox} from "./boxes/slider/toggle-switch-slider.box";
import {ToggleSwitchBox} from "./boxes/toggle-switch.box";

export interface ToggleSwitchComponentProps {
    onToggle: (checked: boolean) => void;
    checked: boolean;
    className?: string;
}
export class ToggleSwitchComponent extends OrbitComponent<ToggleSwitchComponentProps> {

    render() {
        return (<ToggleSwitchBox className={this.props.className}>
            <ToggleSwitchCheckboxBox
                                     checked={this.props.checked}
                                     onChange={(e) => this.props.onToggle(e.target.checked)}/>
            <ToggleSwitchSliderBox checked={this.props.checked}/>
        </ToggleSwitchBox>)
    }
}